<template>
  <BaseLayout>
    <TimelineLoading :step="loadStep" :loading="isLoading" class="h-full w-full min-h-full">
      <div class="flex flex-row items-center justify-center w-full">
        <div class="flex flex-row sm:py-10 w-full sm:w-2/3 xl:w-1/2 items-center justify-center">
          <OfferDetailContext step="PAGAMENTO" id="page-payment" :offer="offer" :isAccordionOpen="true" :keepAccordionOpen="true" :colorSolid="true">

            <div class="flex-1 flex flex-col items-start gap-2 sm:gap-10 w-full p-5">

              <div class="flex flex-col justify-start items-center">
                <mdn-heading :level="2" size="lg">Forma de pagamento</mdn-heading>
                <mdn-text>Insira os dados do seu cartão de crédito</mdn-text>
              </div>

              <div class="flex flex-col w-full">
                <MdnRadio v-if="isCardsFetched"
                  :items="radioButtonCards"
                  :defaultValue="radioDeafultValue"
                  v-on:picked="onPicked"
                >
                  <div slot="MdnRadio_Content" class="pt-8 flex flex-col gap-3">
                    <div v-if="pickedCard === 'NEW'" class="w-full">
                      <iframe
                        v-if="!$isTest"
                        ref="iframe"
                        id="iframe"
                        :src='$options.urlIFrame'
                        width="100%"></iframe>
                    </div>
                    <div v-else>
                      <MdnInput
                        name="cvv"
                        placeholder="CVV"
                        type="text"
                        errorFeedback="Valor inválido."
                        required
                        maxlength="3"
                        mask="999"
                        v-on:input="getCvvInput"
                        :validation="validationCvv"
                        icon="https://ponte-eldorado.frontend-cdn.m4u.com.br/img/cvv.76a3a893.svg"
                      />
                    </div>

                    <div class="pt-5">
                      <Button
                        global
                        id="btn-confirm"
                        :disabled="!enableSubmit"
                        @click="submitTokenize()"
                      >
                        Confirmar adesão
                      </Button>
                    </div>

                  </div>
                </MdnRadio>
              </div>
            </div>
          </OfferDetailContext>

        </div>
      </div>
    </TimelineLoading>
  </BaseLayout>
</template>

<script>
import { singleOfferMixin } from 'business/offers/mixins'
import { loadUserDataMixin } from 'business/user/mixins'
import { saleMixin } from '@/business/sale/mixins'
import { serviceBuilder as paymentService } from '@/business/payment/service'
import { serviceBuilder as offerService } from '@/business/offers/service'
import { serviceBuilder as userService } from '@/business/user/service'
import {
  manageTransactionIdMixin,
  manageConfirmationMixin,
  managePixTransactionMixin,
  manageCardMixin
} from 'business/payment/mixins'
import { useHttpServiceMixin } from '@/common/use-http'
import { stringMonthToInteger } from '@/common/utils'
import { manageIsTelevendasMixin } from './../../business/televendas/mixins'
import { switchOfferNavigationMixin, backButtonNavigationMixin } from 'business/navigation/mixins'
import store from '@/business/store'
import { NotifyUserActionsEnum } from '@/business/http/dto/NotifyUserActionRequest'
import { SMS_STORE_MSISDN_KEY, SMS_STORE_ORIGIN_KEY, SMS_STORE_TELEVENDAS_ID_KEY } from '@/common/constants'
import { MdnHeading, MdnText, Button } from 'mondrian-vue'
import MdnRadio from '../../components/MdnRadio.vue'
import MdnInput from '../../components/MdnInput.vue'
import TimelineLoading, { TIMELINE_LOADING_STEPS } from '../../components/TimelineLoading.vue'
import OfferDetailContext from '../../components/OfferDetailContext.vue'
import { ErrCustom } from '../../business/error/custom-error'
import { TransactionStatusEnum } from '../../business/http/dto/CompleteTransactionResponseDTO'
import { Card } from '../../business/domain/Card'
import { SuccessfulTransaction } from '../../business/domain/SuccessfulTransaction'
import dayjs from 'dayjs'

const PostMessageActions = {
  ready: 'ready',
  tokenize: 'tokenize',
  cvvInfo: 'cvv-info',
  formValid: 'form-valid',
  formInvalid: 'form-invalid',

  validationChanged: 'validation-changed',
  brandChange: 'brand-change',
  tokenizeSuccess: 'tokenize-success',
  tokenizeFail: 'tokenize-fail'
}

class AutorizacaoCreditoFalhaPorSaldo extends ErrCustom {}

export default {
  name: 'page-3-step',
  title: 'Pagamento',
  components: { MdnHeading, MdnText, MdnRadio, MdnInput, Button, TimelineLoading, OfferDetailContext },
  mixins: [
    singleOfferMixin,
    loadUserDataMixin,
    manageTransactionIdMixin,
    manageConfirmationMixin,
    managePixTransactionMixin,
    manageCardMixin,
    manageIsTelevendasMixin,
    useHttpServiceMixin({ paymentService, userService, offerService }),
    switchOfferNavigationMixin,
    backButtonNavigationMixin,
    saleMixin
  ],
  urlIFrame: process.env.VUE_APP_TOKENIZE_IFRAME,
  onOfferError: {
    name: 'page-1-step'
  },
  onUserDataError: {
    name: 'page-2-step'
  },
  data: () => ({
    pickedCard: 'NEW',
    ready: true,
    isValid: false,
    transactionId: null,
    isProcessing: false,
    method: 'CREDITO',
    verifyCount: 0,
    isBridgeFormValid: false,
    panFieldIsValid: false,
    expirationFieldIsValid: false,
    cvvFieldIsValid: false,
    cvvInput: '',
    cards: [],
    isCardsFetched: false,
    loadStep: TIMELINE_LOADING_STEPS.DADOS_CARTAO
  }),
  computed: {
    isLoading () {
      return !this.ready || this.isOfferLoading || this.isProcessing || !this.isCardsFetched
    },
    radioButtonCards () {
      const radioButtonCards = this.cards
        .map(card => ({ name: `${card.bandeira} final ${card.ultimosDigitos}`, value: card.token, bandeira: card.bandeira }))
      return [...radioButtonCards.slice(0, 3), { name: 'Usar um novo cartão', value: 'NEW' }]
    },
    radioDeafultValue () {
      return this.cards.length > 0 ? this.cards[0].token : 'NEW'
    },
    enableSubmit () {
      if (this.pickedCard === 'NEW' && this.isBridgeFormValid) return true
      else if (this.pickedCard !== 'NEW' && this.cvvInput.length === 3) return true

      return false
    }
  },
  methods: {
    onPicked (event) {
      this.cvvInput = ''
      this.pickedCard = event
    },
    onMessage (e) {
      if (!e.data) {
        return
      }
      const data = JSON.parse(e.data)

      switch (data.action) {
        case PostMessageActions.tokenizeSuccess: {
          this.onTokenized(data.data.card)
          break
        }
        case PostMessageActions.tokenizeFail: {
          this.$router.replace({
            name: 'page-error'
          })
          break
        }
        case PostMessageActions.ready: {
          this.ready = true
          break
        }
        case PostMessageActions.validationChanged: {
          this.validateField(data.data.field, data.data.isValid)
          break
        }
        default: {
          console.warn("unknow event", e); // eslint-disable-line
        }
      }
    },
    validateField (field, isValid) {
      switch (field) {
        case 'pan': {
          isValid ? this.panFieldIsValid = true : this.panFieldIsValid = false
          this.validateBridgeForm()
          break
        }
        case 'expiration': {
          isValid ? this.expirationFieldIsValid = true : this.expirationFieldIsValid = false
          this.validateBridgeForm()
          break
        }
        case 'cvv': {
          isValid ? this.cvvFieldIsValid = true : this.cvvFieldIsValid = false
          this.validateBridgeForm()
          break
        }
        default: {
          console.warn("unknow field", field); // eslint-disable-line
        }
      }
    },
    validateBridgeForm () {
      if (this.panFieldIsValid && this.expirationFieldIsValid && this.cvvFieldIsValid) {
        this.isBridgeFormValid = true
      } else {
        this.isBridgeFormValid = false
      }
    },
    async onTokenized (card) {
      this.$tracker.log('clique:contratar', 'cvv-cartao')
      try {
        const formattedCard = new Card(card.key, card.expirationYear, card.expirationMonth, card.brand, card.last, card.cvv, 'PENDING')
        await this.storeCard(formattedCard)

        let shouldValidateOtp = false
        if (this.validateInLastStep(this.userData.msisdn)) {
          const validationResponse = await this.initialValidation(this.userData.cpf, this.userData.msisdn)
          shouldValidateOtp = validationResponse.shouldValidateOtp
          this.confirmUserInitialValidation(true)
        }

        if (!shouldValidateOtp) {
          await this.completePayment(card)
        }
      } catch (err) {
        this.$tracker.error(err)
        const canPayWithPix = err instanceof AutorizacaoCreditoFalhaPorSaldo
        this.$router.replace({
          name: 'page-payment-error',
          params: { canPayWithPix, linkTo: '/3-step' }
        })
      }
    },
    submitTokenize () {
      this.$tracker.log('clique:prosseguir', 'dados-cartao')
      this.isProcessing = true

      if (this.pickedCard === 'NEW') {
        try {
          this.$refs.iframe.contentWindow.postMessage(
            { action: PostMessageActions.tokenize },
            this.$options.urlIFrame
          )
        } catch (err) {
          this.$tracker.error(err)
          this.$router.push({
            name: 'page-error'
          })
        }
      } else {
        const card = this.cards.find(card => card.token === this.pickedCard)
        this.onTokenized({
          brand: card.bandeira,
          key: card.token,
          cvv: this.cvvInput,
          last: card.ultimosDigitos,
          expirationMonth: stringMonthToInteger(card.mesValidade),
          expirationYear: card.anoValidade
        })
      }
    },
    async completePayment (card) {
      this.loadStep = TIMELINE_LOADING_STEPS.PAGAMENTO
      const { userData: { cpf, msisdn }, offerId, method } = this
      const payload = {
        cardToken: card.key,
        cvv: card.cvv,
        cpf,
        msisdn,
        productId: offerId,
        method
      }

      const response = await this.$paymentService.completeTransaction(payload)
        .catch(e => {
          this.changeCardStatus('FAILED')
          throw e
        })
      const tid = response?.idPedidoVenda
      await this.storeTransactionId(tid)
      this.transactionId = tid

      if (response.status === TransactionStatusEnum.PAGAMENTO_PENDENTE && response.codigoPix) {
        const pixTransaction = { idPedidoVenda: response.idPedidoVenda, qrCode: response.codigoPix, dataExpiracao: response.expiracaoPix }
        await this.storePixTransaction(pixTransaction)
        throw new AutorizacaoCreditoFalhaPorSaldo()
      } else if (response.status !== TransactionStatusEnum.EM_PROCESSAMENTO) {
        throw new Error('Falha desconhecida no pagamento')
      } else {
        this.changeCardStatus('SUCCESS')
        const confirmation = new SuccessfulTransaction(dayjs(), card.last, card.brand, msisdn)
        await this.storeSuccessfulTransaction(confirmation)
        this.notifyAction()
        this.$tracker.log('tentativa:migracao', 'sucesso')
        this.$router.replace({
          name: 'page-success'
        })
      }
    },
    async notifyAction () {
      const { offerId } = this
      const msisdn = await store.get(SMS_STORE_MSISDN_KEY)
      const origin = await store.get(SMS_STORE_ORIGIN_KEY)
      const televendasId = await store.get(SMS_STORE_TELEVENDAS_ID_KEY)
      const extra = { offerId, origin }
      await this.$userService.notifyUserActionWithTelevendasId(msisdn, NotifyUserActionsEnum.ADESAO, extra, televendasId)
    },
    async fetchCards () {
      try {
        await this.loadUserData()
        const msisdn = this.userData.msisdn

        await this.loadUserCards()
        let userCards = this.userCards
        if (!userCards.length && msisdn) {
          await this.fetchCardsService(msisdn)
          await this.loadUserCards()
          userCards = this.userCards
        }

        if (userCards.length) {
          this.onPicked(userCards[0].token)
        }
        this.cards = userCards ?? []
      } catch (e) {
        this.cards = []
      }
      this.isCardsFetched = true
    },
    getCvvInput (event) {
      this.cvvInput = event.value
    },
    validationCvv (value) {
      return value.length === 3 && value.replace(/D/g, '').length === 3
    }
  },
  async mounted () {
    this.$onMessage = this.onMessage.bind(this)

    window.addEventListener('message', this.$onMessage)

    await this.loadIsTelevendas()
      .then(isTelevendas => {
        if (isTelevendas) this.setShowBackButton(false)
      })
      .catch(err => {
        this.$tracker.error(err)
      })

    const selectedCard = await this.loadCard()

    if (selectedCard && selectedCard.token && selectedCard.cvv && selectedCard.paymentStatus === 'PENDING') {
      try {
        await this.completePayment({
          brand: selectedCard.brand,
          key: selectedCard.token,
          cvv: selectedCard.cvv,
          last: selectedCard.last,
          expirationMonth: selectedCard.month,
          expirationYear: selectedCard.year
        })
      } catch (err) {
        this.$tracker.error(err)
        const canPayWithPix = err instanceof AutorizacaoCreditoFalhaPorSaldo
        this.$router.replace({
          name: 'page-payment-error',
          params: { canPayWithPix, linkTo: '/3-step' }
        })
      }
    } else {
      await this.fetchCards()
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.$onMessage)
  }
}
</script>
